import React from 'react';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import Input from 'components/Input';
import CloseIcon from 'resources/X_close_icon.png';
import WStoreFilterCalendar from './WStoreFilterCalendar';
import './WStoreFilterMenu.css';

const WStoreFilterMenu = ({
  showFilterMenu,
  onClose,
  tempDateFilter,
  filteredItemsCount,
  handleClearFilters,
  handleApplyFilters,
  handleChangeTempFilter
}) => {
  return (
    <Modal
      className="wstore-filter-menu"
      show={showFilterMenu}
      onHide={onClose}
    >
      <Modal.Body>
        <button type="button" className="close-button" onClick={onClose}>
          <img src={CloseIcon} alt="Close Filter Menu" />
        </button>
        <div className="title-section">
          <div className="title">Filters</div>
        </div>
        <div className="body-section">
          <div className="date-range-section">
            <div className="date-range-title">Date Range</div>
            <div>
              <Input
                type="checkbox"
                label="All"
                checked={tempDateFilter.all}
                onChange={() => handleChangeTempFilter('all')}
              />
              <Input
                type="checkbox"
                label="Today"
                checked={tempDateFilter.today}
                onChange={() => handleChangeTempFilter('today')}
              />
              <Input
                type="checkbox"
                label="Tomorrow"
                checked={tempDateFilter.tomorrow}
                onChange={() => handleChangeTempFilter('tomorrow')}
              />
              <Input
                type="checkbox"
                label="This Week"
                checked={tempDateFilter.thisWeek}
                onChange={() => handleChangeTempFilter('thisWeek')}
              />
              <Input
                type="checkbox"
                label="Exact Date"
                checked={tempDateFilter.exactDate}
                onChange={() => handleChangeTempFilter('exactDate')}
              />
            </div>
          </div>
          {tempDateFilter.exactDate ? (
            <WStoreFilterCalendar
              exactDate={
                moment.isMoment(tempDateFilter.exactDate) &&
                tempDateFilter.exactDate
              }
              handleSelectDate={handleChangeTempFilter}
            />
          ) : (
            <div className="calendar-placeholder" />
          )}
        </div>
        <div className="footer-section">
          <button
            type="button"
            onClick={handleClearFilters}
            className="clear-filters-button"
          >
            Clear all
          </button>
          <button
            type="button"
            onClick={handleApplyFilters}
            className="apply-filters-button"
            disabled={!filteredItemsCount}
          >
            {`Show ${filteredItemsCount ? filteredItemsCount : ''} items`}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default WStoreFilterMenu;
